import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Footprints, ArrowLeft, KeyRound } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Kata sandi minimal 6 karakter"); return; }
    if (pw !== pw2) { toast.error("Konfirmasi kata sandi tidak sama"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success("Kata sandi berhasil diubah. Silakan masuk.");
      nav("/masuk");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] grain flex flex-col">
      <div className="max-w-6xl w-full mx-auto px-4 h-16 flex items-center">
        <Link to="/masuk" className="flex items-center gap-2 text-[#5C5F5C] hover:text-[#1A1C1A] transition-colors text-sm">
          <ArrowLeft className="h-4 w-4" /> Kembali ke Masuk
        </Link>
      </div>
      <div className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2 mb-6 justify-center">
            <img src="/talenta-logo.png" alt="TalentaPath" className="h-11 w-11 rounded-full object-contain" />
            <span className="flex flex-col leading-none">
              <span className="font-heading font-black text-xl text-[#1A1C1A]">TalentaPath</span>
              <span className="text-xs font-medium text-[#E25E3E]">powered by Talenta</span>
            </span>
          </div>
          <div className="clay-card p-7" data-testid="reset-password-card">
            <span className="h-12 w-12 rounded-2xl bg-[#E25E3E]/12 text-[#E25E3E] grid place-items-center mb-4"><KeyRound className="h-6 w-6" /></span>
            <h1 className="font-heading font-black text-2xl mb-1 text-[#1A1C1A]">Atur ulang kata sandi</h1>
            {!token ? (
              <p className="text-sm text-[#D9381E] mt-2" data-testid="reset-no-token">Tautan tidak valid. Silakan minta tautan reset baru dari halaman "Lupa kata sandi".</p>
            ) : (
              <>
                <p className="text-sm text-[#5C5F5C] mb-6">Buat kata sandi baru untuk akunmu.</p>
                <form onSubmit={submit} className="space-y-4">
                  <label className="block">
                    <span className="block text-sm font-medium text-[#1A1C1A] mb-1.5">Kata Sandi Baru</span>
                    <input required type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-pw-input"
                      className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E0D8] bg-white outline-none focus:border-[#E25E3E]" placeholder="Minimal 6 karakter" />
                  </label>
                  <label className="block">
                    <span className="block text-sm font-medium text-[#1A1C1A] mb-1.5">Ulangi Kata Sandi</span>
                    <input required type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-pw2-input"
                      className="w-full px-3.5 py-2.5 rounded-lg border border-[#E5E0D8] bg-white outline-none focus:border-[#E25E3E]" placeholder="Ketik ulang" />
                  </label>
                  <button type="submit" disabled={loading} data-testid="reset-submit-btn"
                    className="w-full py-3.5 rounded-full bg-[#E25E3E] text-white font-medium hover:bg-[#C94F31] transition-colors disabled:opacity-60">
                    {loading ? "Menyimpan…" : "Simpan Kata Sandi Baru"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
